module.exports = __webpack_public_path__ + "img/1.7bbe2ca2.jpg";